(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rc-product-technology"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
   const button = event.target.closest('[data-study-open]');
   if (button) {
     const dialog = document.getElementById(button.dataset.studyOpen);
     if (!dialog || dialog.open) return;
     dialog.addEventListener('close', () => {
       if (button.isConnected) button.focus({ preventScroll: true });
     }, { once: true });
     dialog.showModal();
   } else if (event.target.matches('dialog.rc-product-study')) {
     const dialog = event.target;
     const rect = dialog.getBoundingClientRect();
     if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
   }
 });
  } catch(e) { console.error(e); }
})();

})();
